// Copy of the "Customers" walkthrough. The rules every text follows are in ../../de/help.js.
// Tab and button names are written as the customer page shows them (../customer.js).
export default {
  title: "Customers",
  // Short names of the views, for the header, the timeline and "Continue to …".
  section: {
    CustomerOverview: "Overview",
    CustomerDetail: "Customer page",
    ProjectDetail: "Project",
    SettingsOverview: "Settings",
  },
  related: "Connections",
  step: {
    list: {
      text: "Every customer of your company is listed here, each with a page of its own.",
    },
    row: {
      text: "A row shows the company and its town, the first contact person with their phone, and the number of projects. The number opens exactly those projects, a click on the row the customer's page.",
    },
    create: {
      text: "Create new customer opens the empty form. All it needs is a name.",
    },
    head: {
      text: "The name of the customer sits at the top. Below it, who created the record and last changed it.",
    },
    actions: {
      text: "Actions is where you delete the customer. It asks first.",
    },
    tabs: {
      text: "The tabs divide the record up. Behind the arrow on the right sit File storage, Configuration and Activity.",
    },
    general: {
      text: "General holds the name, the address and the notes. Search for the address or fill the fields in by hand.",
    },
    contacts: {
      text: "These are the customer's contacts with their position. Every project of this customer can take them over.",
    },
    machines: {
      text: "Here you set a selling price of your own, per machine, for this one customer. A single project can still override it. The purchase prices belong to the machine. The star picks which of them a project for this customer starts with.",
    },
    "assign-open": {
      text: "Assign machine opens the catalogue. Whatever the customer already has does not show up here.",
    },
    "assign-pick": {
      text: "A click ticks a row, and several go at once. A packet brings all of its machines along.",
    },
    "assign-add": {
      text: "Add takes the selection into the list, without a price of its own yet. It is saved together with the record.",
    },
    materials: {
      text: "The same for materials. A project of this customer takes the price over as the material is added, and can override it there.",
    },
    efforts: {
      text: "And the same for efforts such as travel or disposal. This price, too, can be overridden in each project.",
    },
    "price-modes": {
      text: "A selling price is either a fixed amount or a surcharge in percent. The sign in the field switches between them, and to “At purchase price” and “Free of charge”.",
    },
    positions: {
      text: "This is the hourly rate you agreed with the customer. A project of this customer proposes it for its employee positions.",
    },
    save: {
      text: "Save writes every tab at once. A tab with an error in it is brought to the front.",
    },
    again: {
      text: "This button is on every page that has an explanation. One click starts it again.",
    },
    // Setup: what a customer does outside its own page.
    "project-customer": {
      text: "Every project belongs to a customer. You pick it here as the project is created, and it is fixed after that.",
    },
    currency: {
      text: "The prices and hourly rates of a customer's record are in this currency. A customer can also get one of its own on the Configuration tab.",
    },
  },
}
